<template>
    <div class="card mb-3">
        <div class="card-body">
            <router-link :to="{name: 'organization.create'}" class="btn btn-success ml-2">ایجاد سفارش</router-link>
            <hr>
            <Loading v-if="showLoading" />
            <DataTable :columns="columns" :rows="rows" v-if="rows.length" :count="count" :url="'Orders/Search'" :operations="['orders',{show: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}]" :shippings="shippings" />
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            columns: [
                {
                    title: 'شناسه',
                    field: 'orderId'
                },
                {
                    title: 'نام',
                    field: 'fullName'
                },
                {
                    title: 'شناسه ملی',
                    field: 'nationalCode'
                },
                {
                    title: 'وضعیت سفارش',
                    field: 'statusTitle'
                },
                {
                    title: 'نوع سفارش',
                    field: 'orderType'
                },
                {
                    title: 'پرداخت',
                    field: 'paymentStatusTitle'
                },
                {
                    title: 'مبلغ',
                    field: 'amount'
                },
                {
                    title: 'تاریخ',
                    field: 'createdAt'
                },
                {
                    title: 'ساعت',
                    field: 'createdAtTime'
                }
            ],
            shippings: {},
            rows: [],
            count: 0,
            showLoading: true
        }
    },
    methods: {
        async getData(){
            await this.$api.get('Shipping').then(({data}) => {
                data.result.map(shipping => {
                    this.shippings[shipping.shippingId] = shipping.title;
                });
            });
            this.$api.post('Organizations/Orders/Search',{
                page: 1,
                perPage: 10
            }).then(({data}) => {
                if(data.list){
                    this.rows = [];
                    data.list.map(order => {
                        this.rows.push({
                            ...order,
                            fullName: order.firstName + ' ' + order.lastName,
                            amount: new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.amount) + ' ریال',
                            shipping: this.shippings[order.shippingId]
                        });
                    });
                    this.count = data.count;
                    this.rows.operations = ['organization',{show: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}];
                }
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>